export default __webpack_public_path__ + "static/media/mail_desable.9f5e6910.svg";